import React from "react";
import classnames from "classnames";
import "./FileUploader.css";
import Button from "../button/Button";


export interface IFileUploaderWandaProps {
  /** Everything wrapped in the tag. Usually just the buttons title. */
  children: any;
  /** The styles that will be applied */
  className?: string;
  /** This will default the file selector to a pre-defined filter. Accepts a string of comma seperated extensions. i.e ".xls,.xlsx"
   * If not set the default is all files */
  filter?: string;
  /** the callback that will be fired. This will recieve a File object */
  clickHandler?: (e: any) => void;
  /** Whether the button is disabled */
  disabled?: boolean;
  /** Type of button style to display alternate=custom | error=red | success=green | undefined=blue */
  styleType?: "alternate" | "error" | "success";
  
}

export default function FileUploaderWanda(props: IFileUploaderWandaProps) {
  const {
    children,
    className,
    disabled,
    clickHandler,
    styleType,
    filter,
  } = props;

  const hiddenFileInput = React.useRef<HTMLInputElement>(null);

  function handleClick(e: any) {
    hiddenFileInput.current!.click();
  }

  const handleChange = (event: any) => {
    const fileUploaded = event.target.files[0];
    if (clickHandler) {
      clickHandler(fileUploaded);
    }
  };

  const handleClickEvent =(event: any)=>{
    event.target.value = null;
  }

  return (
    <Button
      disabled={disabled}
      className={classnames("mtm-btn", className, {
        "mtm-btn-alternative": styleType === "alternate",
        "mtm-btn-disabled": disabled,
        "mtm-btn-error": styleType === "error",
        "mtm-btn-success": styleType === "success",
      })}
      clickHandler={handleClick}
      type="button"
    >
      <input
        type="file"
        accept={filter}
        ref={hiddenFileInput}
        onChange={handleChange}
        style={{ display: "none" }}
        onClick={handleClickEvent}
      />
      {children}
    </Button>
  );
}
